import React, { useEffect, useRef, useMemo } from "react";
import "./LoadingDoorComponent.css";
import txtIndicator from "../../assets/text-indicator.svg";

import soundWoosh from '../../assets/audios/woosh.mp3';


const stateMessages = {
    standBy: "Esperando...",
    welcome: "¡Bienvenido al juego!",
    spinner: "¡Preparando la siguiente ronda!",
    joker: "Activando comodín...",
    in_round: "¡A jugar!",
    qualification: "Calificando...",
    ranking: "Mostrando ranking...",
    grading: "Evaluando respuestas...",
    final_ranking: "Ranking final...",
    finished: "Juego terminado.",
};

const getMessageForTransition = (previousState, currentState) => {
    if (previousState === currentState) return stateMessages[currentState] || "Cambiando estado...";

    if (previousState === "welcome" && currentState === "spinner") return "¡Preparando la siguiente ronda!";
    if (previousState === "spinner" && currentState === "joker") return "¡El comodín entra en juego!";
    if (previousState === "joker" && currentState === "in_round") return "¡Prepárate para la ronda!";
    if (previousState === "in_round" && currentState === "qualification") return "Evaluando respuestas...";
    if (previousState === "qualification" && currentState === "ranking") return "Actualizando ranking...";
    if (previousState === "ranking" && currentState === "grading") return "Calculando puntuaciones...";
    if (previousState === "grading" && currentState === "final_ranking") return "Mostrando ranking final...";
    if (previousState === "final_ranking" && currentState === "finished") return "Juego terminado.";

    return stateMessages[currentState] || "Cambiando estado...";
};

//ORLA NOTES, vamos a empezar por simplificar este componente, deberiamos solo abrirlo y cerrarlo
//sin estar atado a logicas de juego?

const LoadingDoorComponent = ({ open }) => {
    const doorRef = useRef();

    let sound;

    const playSoundWoosh = (isPlay) => {
        if (!sound || sound.ended) {
            sound = new Audio(soundWoosh);
            if(!isPlay){
                sound.play();
            }else{
                sound.pause();  
            }
            

            // Detener el sonido después de 1 segundo
            // setTimeout(() => {
            //     sound.pause();
            //     sound.currentTime = 0; // Reinicia el audio para la próxima reproducción
            // }, 1000);
        }
    };

    useEffect(() => {
        playSoundWoosh(open);
    }, [open]);


    /*
    const lastState = useMemo(() => {
        return game?.previousStates?.length > 0 ? game.previousStates[game.previousStates.length - 1] : null;
    }, [game?.previousStates]);

    const message = useMemo(() => getMessageForTransition(lastState, game?.state), [lastState, game?.state]);

    
    useEffect(() => {
        if (game?.state) {
            toggleDoor();
        }
    }, [game?.state]);
  

    const toggleDoor = () => {
        if (doorRef.current) {
            // Cierra la puerta
            doorRef.current.classList.remove("open");
            doorRef.current.classList.add("close");

            // Abre la puerta después de 3 segundos
            setTimeout(() => {
                doorRef.current.classList.remove("close");
                doorRef.current.classList.add("open");
            }, 3000);
        }
    };
    */

    return (
        <div ref={doorRef} className={"door " + (open ? "open" : "close")}>
            <div className="box-l">
                <div className="zig-zag-line"></div>
            </div>
            <div className="box-r">
                <div className="zig-zag-line"></div>
            </div>
            {/*game?.state && (
                <div className="central">
                    <div className="centralPanel">
                        <label>{message}</label>
                    </div>
                    {/* <img className="txtIndicator" src={txtIndicator} alt="txt indicator" />
                </div>
            ) */}
        </div>
    );
};

export default LoadingDoorComponent;
